import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "superuser-companies-list flex p3" }
const _hoisted_2 = /*#__PURE__*/_createVNode("b", null, "Code", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("b", null, "Balance", -1)
const _hoisted_4 = {
  key: 0,
  class: "package-item"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("b", null, "Bought on", -1)
const _hoisted_6 = { class: "flex flex-wrap" }
const _hoisted_7 = /*#__PURE__*/_createVNode("b", null, "Games left", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_9 = { class: "flex flex-wrap" }
const _hoisted_10 = /*#__PURE__*/_createVNode("b", null, "Your subscription", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_12 = /*#__PURE__*/_createVNode("b", null, "Net Price", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("b", null, "Gross Price", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("b", null, "Package IDs", -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" See company ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateAllCompaniesTest && _ctx.updateAllCompaniesTest(...args)))
    }, "FUN_TEAM_CLUES_WORDS"),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_DataTable, {
        value: _ctx.allCompanies,
        responsiveLayout: "scroll"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "id",
            header: "ID"
          }),
          _createVNode(_component_Column, {
            field: "name",
            header: "Name"
          }),
          _createVNode(_component_Column, {
            field: "email",
            header: "Email"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.userEmails[0]), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "logo",
            header: "Logo"
          }, {
            body: _withCtx((slotProps) => [
              _createVNode("img", {
                class: "logo",
                src: slotProps.data.logo,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("div", {
                style: {
              background: slotProps.data.brandColor,
              width: '30px',
              height: '30px',
              marginRight: '6px'
            }
              }, null, 4)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "currency",
            header: "Currency"
          }),
          _createVNode(_component_Column, {
            field: "referral",
            header: "Referrals"
          }, {
            body: _withCtx((slotProps) => [
              _createVNode("div", null, [
                _hoisted_2,
                _createTextVNode(" : " + _toDisplayString(slotProps.data.referralCode), 1)
              ]),
              _createVNode("div", null, [
                _hoisted_3,
                _createTextVNode(" : " + _toDisplayString(slotProps.data.referralData.balance), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "package",
            header: "Package"
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.package)
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    _createVNode("div", null, [
                      _hoisted_5,
                      _createTextVNode(" : " + _toDisplayString(_ctx.formatDate(slotProps.data.package.boughtOn)), 1)
                    ]),
                    _createVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _hoisted_8,
                      _createVNode("div", null, _toDisplayString(_ctx.GAME_NAMES_HUMANIZED.FUN_BUSINESS_GAME) + ": " + _toDisplayString(slotProps.data.package.gamesLeft[_ctx.GAME_NAMES.FUN_BUSINESS_GAME]) + ", ", 1),
                      _createVNode("div", null, _toDisplayString(_ctx.GAME_NAMES_HUMANIZED.FUN_TEAM_BIDDING) + ": " + _toDisplayString(slotProps.data.package.gamesLeft[_ctx.GAME_NAMES.FUN_TEAM_BIDDING]) + ", ", 1),
                      _createVNode("div", null, _toDisplayString(_ctx.GAME_NAMES_HUMANIZED.FUN_ICE_BREAKER) + ": " + _toDisplayString(slotProps.data.package.gamesLeft[_ctx.GAME_NAMES.FUN_ICE_BREAKER]), 1)
                    ]),
                    _createVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _hoisted_11,
                      _createVNode("div", null, _toDisplayString(_ctx.GAME_NAMES_HUMANIZED.FUN_BUSINESS_GAME) + ": " + _toDisplayString(slotProps.data.package.gamesLeft[_ctx.GAME_NAMES.FUN_BUSINESS_GAME]) + ", ", 1),
                      _createVNode("div", null, _toDisplayString(_ctx.GAME_NAMES_HUMANIZED.FUN_TEAM_BIDDING) + ": " + _toDisplayString(slotProps.data.package.gamesLeft[_ctx.GAME_NAMES.FUN_TEAM_BIDDING]) + ", ", 1),
                      _createVNode("div", null, _toDisplayString(_ctx.GAME_NAMES_HUMANIZED.FUN_ICE_BREAKER) + ": " + _toDisplayString(slotProps.data.package.gamesLeft[_ctx.GAME_NAMES.FUN_ICE_BREAKER]), 1)
                    ]),
                    _createVNode("div", null, [
                      _hoisted_12,
                      _createTextVNode(" : " + _toDisplayString(slotProps.data.package.price), 1)
                    ]),
                    _createVNode("div", null, [
                      _hoisted_13,
                      _createTextVNode(" : " + _toDisplayString((slotProps.data.package.price * 1.23).toFixed(2)), 1)
                    ]),
                    _createVNode("div", null, [
                      _hoisted_14,
                      _createTextVNode(" : " + _toDisplayString(slotProps.data.package.packageId), 1)
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_15, "No package"))
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "userEmails",
            header: "Users"
          }, {
            body: _withCtx((slotProps) => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.data.userEmails, (user) => {
                return (_openBlock(), _createBlock("div", { key: user }, _toDisplayString(user), 1))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "actions",
            header: "Actions"
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Button, {
                onClick: ($event: any) => (_ctx.$router.push(`/superuser-panel/${slotProps.data.id}`))
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ])
  ], 64))
}